import { Select, FormLabel, Input, Box,InputGroup, InputRightElement} from '@chakra-ui/react'
import {useState} from 'react';

export default function Dokument({migracija_tip_sifra="",dokumenti=[],onDokumentTipIdChange,onDokumentBrChange, defaultDokumentTipId=0, defaultDokumentBroj="",readonly=false,size='xs'}) {
const [state,setState]=useState({doktipid:defaultDokumentTipId,dokumentbr:defaultDokumentBroj,dokmentBrDisabled:false})



const dokumentSelect=(event)=>{

    
    if (event.target.value==="100000") {
        onDokumentBrChange("");
        setState({...state,doktipid:event.target.value,dokumentbr:"",dokumentBrDisabled:true})
    } else {
        setState({...state,doktipid:event.target.value,dokumentBrDisabled:false})
    }
    onDokumentTipIdChange(event.target.value);
    
}

const showInputBrojDokumenta=()=>{
    
        return (<Input focusBorderColor='grunt2.400' size={size} maxLength={30} variant={'filled'} placeholder='Broj dokumenta' isDisabled={state.dokumentBrDisabled}  value={state.dokumentbr} onChange={dokumentBrChange} display={'block'}></Input>)
    

}

const dokumentBrChange=(event)=>{
    setState({...state,dokumentbr:event.target.value.toUpperCase()});
    onDokumentBrChange(event.target.value);
}

    const showData=()=>{
        
        
        /*if (dokumenti.length===0) {
            return (
            <>
           
            </>
            )
        } else {*/
        return (
            <Box display={'flex'} flexDir={'row'} gap={'0.5rem'} w='100%'>
            <Box w='50%' display={'flex'} flexDir={'column'}>
                <FormLabel fontSize={size}>Vrsta dokumenta</FormLabel>
            <Select focusBorderColor='grunt2.400' size={'xs'} isDisabled={readonly} variant={'filled'} maxLength={50} onChange={dokumentSelect}  display={'block'}>
                {dokumenti.map((item,i)=>{
                    // if (item.migracija_tip_sifra===migracija_tip_sifra) { 
                        return (<option key={i} value={item.dokument_tip_id}>{item.dokument_naziv}</option>)
                    // }
                    
                })}
            </Select>
            </Box>
            <Box w='50%' display={'flex'} flexDir={'column'}>
            <FormLabel fontSize={size}>Broj dokumenta</FormLabel>
            <InputGroup size={size}>
            <InputRightElement pointerEvents={'none'} fontSize='1.2rem' fontWeight={'bold'} children={'#'}/>
            {showInputBrojDokumenta()}
            </InputGroup>
            </Box>
            </Box>
        )
           // }   
        
    }

  return (
        <Box flexDir={'row'} display='flex' gap={'0.2rem'}>{showData()}</Box>
        
    
  )
}
